import { render } from "./questionDetail.vue?vue&type=template&id=4ed61e36&scoped=true"
import script from "./questionDetail.vue?vue&type=script&lang=js"
export * from "./questionDetail.vue?vue&type=script&lang=js"

import "./questionDetail.vue?vue&type=style&index=0&id=4ed61e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed61e36"]])

export default __exports__